// NOTE: imported from the concrete module rather than the `../types` barrel,
// for the same cycle reason spelled out in `./organization.ts`.
import type { IParsedProject } from "../types/projects";

export const PROJECTS_QUERY_KEY = "projects";

export const PROJECT_MEMBERS_QUERY_KEY = "project-members";

export const PROJECT_ROLES_QUERY_KEY = "project-roles";

export const PERMISSIONS_QUERY_KEY = "permissions";

export const PROJECTS_REFETCH_INTERVAL_MS = 10_000;

// NOTE: NSAI-4567 — stable empty result for the project lists. See the block
// above `EMPTY_ORGANIZATIONS` in `./organization.ts` for why a `= []` literal
// default is what turns an unresolved query into a render loop. Not frozen, for
// the same reason.
export const EMPTY_PROJECTS: IParsedProject[] = [];
